import { createTheme, ThemeOptions } from '@mui/material/styles';
import { hoverFix } from './styles/mixins';

const TYPOGRAPHY_HEADING_XLARGE = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '26px',
  lineHeight: '32px',
  fontWeight: 300,
  fontVariationSettings: '"wght" 300',
};

const TYPOGRAPHY_HEADING_LARGE = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '23px',
  lineHeight: '28px',
  fontWeight: 400,
  fontVariationSettings: '"wght" 400',
};

const TYPOGRAPHY_HEADING_MEDIUM = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '20px',
  lineHeight: '24px',
  fontWeight: 400,
  fontVariationSettings: '"wght" 400',
};

export const MindTickleThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#2b21ba',
      dark: '#2b21ba',
      light: '#2b21ba',
    },
    secondary: {
      dark: '#2b21ba',
      main: '#2b21ba',
      light: '#e6e5fa',
    },
    error: {
      main: '#FF6969',
    },
    icon: {
      main: '#2b21ba',
    },
    background: {
      default: '#e0e0e0',
    },
    common: {
      white: '#fff',
      black: '#000',
    },
  },
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    h1: {
      ...TYPOGRAPHY_HEADING_XLARGE,
    },
    h4: {
      ...TYPOGRAPHY_HEADING_XLARGE,
    },
    h2: {
      ...TYPOGRAPHY_HEADING_LARGE,
    },
    h5: {
      ...TYPOGRAPHY_HEADING_LARGE,
    },
    h3: {
      ...TYPOGRAPHY_HEADING_MEDIUM,
    },
    h6: {
      ...TYPOGRAPHY_HEADING_MEDIUM,
    },
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          '& .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"].Mui-focused':
            {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                color: 'inherit',
              },
              '&:hover *': {
                color: 'inherit !important',
              },
            },
          '& .MuiAutocomplete-option:hover': {
            backgroundColor: 'var(--color-bg-accent)',
            color: 'var(--color-text-inverse)',
          },
          '& .MuiAutocomplete-option:hover *': {
            color: 'var(--color-text-inverse) !important',
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          textTransform: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlinedSecondary: {
          backgroundColor: 'white',
          fontWeight: '500 !important',
          fontSize: '14px !important',
          height: '32px !important',
        },
        root: {
          fontWeight: '500 !important',
          textTransform: 'none',
          fontSize: '14px !important',
          height: '32px !important',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          ...hoverFix,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          ...hoverFix,
          '&:hover': {
            backgroundColor: 'var(--color-bg-accent)',
            color: 'var(--color-text-inverse)',
          },
          '&:hover *': {
            color: 'var(--color-text-inverse) !important',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              color: 'inherit',
            },
            '&:hover *': {
              color: 'inherit !important',
            },
          },
          '& .MuiListItemIcon-root': {
            minWidth: '24px',
          },
          '& .MuiListItemText-root': {
            marginBottom: '4px',
            marginTop: '4px',
          },
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        arrow: {
          color: 'var(--tooltip-solid-color)',
        },
        tooltip: {
          backgroundColor: 'var(--tooltip-solid-color)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '14px !important',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: '14px !important',
        },
      },
    },
  },
};

export default createTheme(MindTickleThemeOptions);
